:host {
  @include reset-host;

  efb-click-action {
    height: 100%;
  }
}

:host .external-article-slide {
  display: flex;
  flex-direction: column;
  height: 100%; // useful for same-height slider slides
  overflow: hidden;

  text-align: left;

  background: $white;
  border-radius: $radius-md;

  .head {
    width: 100%;
  }

  .head-img {
    position: relative;
    aspect-ratio: 352 / 220;
  }

  .body {
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: rem(18) rem(24);
  }

  .title {
    font-weight: $fw-medium;
    font-size: $fs-xl;
  }

  .text {
    flex: 1;
  }

  .buttons {
    display: flex;
    margin-top: rem(25);
  }

  .button {
    display: inline-flex;
    align-items: center;
    height: rem(30);
    padding: 2px 12px;

    color: $color-purple;

    font-weight: $fw-bold;
    text-decoration: none;

    border: 1px solid $color-purple;
    border-radius: rem(100);
  }
}
